import { genericRoute } from 'utils/routeUtils';

import GolfHomePage from './containers/GolfHomePage';
import GolfNav from './nav/GolfNav';

export default genericRoute(GolfHomePage, GolfNav, 'golf');



// WEBPACK FOOTER //
// ./modules/Golf/routes.js